export const statusOptions = [
  { value: 'ACTIVE', label: 'Activo' },
  { value: 'INACTIVE', label: 'Inactivo' }
];

export const permissionsOptions = [
  { value: 'DASHBOARD', label: 'Dashboard' },
  { value: 'USERS', label: 'Usuarios' },
  { value: 'ADMINS', label: 'Administradores' },
  { value: 'ROADS', label: 'Caminos' },
  { value: 'RANKING', label: 'Ranking' },
  { value: 'NOTIFICATION', label: 'Notificaciones' },
  { value: 'ACHIEVEMENTS', label: 'Mis Logros' },
  { value: 'INCOME', label: 'Ingresos' },
  { value: 'AUDIOHISTORY', label: 'Historial de audios' },
  { value: 'FEEDBACK', label: 'Feedback' },
  { value: 'CONFIG', label: 'Configuración' }
];

export const genderOptions = [
  { value: 'MALE', label: 'Masculino' },
  { value: 'FEMALE', label: 'Femenino' },
  { value: 'OTHER', label: 'Otro' }
];

export const membershipOptions = [
  { value: 'FREE', label: 'Free' },
  { value: 'FREEMIUM', label: 'Freemium' },
  { value: 'PREMIUM', label: 'Premium' },
  { value: 'TEMPORAL', label: 'Temporal' }
];

export const scheduledMembershipOptions = [
  { value: 'FREE', label: 'Free' },
  { value: 'FREEMIUM', label: 'Freemium' },
  { value: 'PREMIUM', label: 'Premium' },
  { value: 'TEMPORAL', label: 'Temporal' }
];

export const achievementsOptions = [
  { value: 'road', label: 'Caminos' },
  { value: 'episode', label: 'Episodios' },
  { value: 'streak', label: 'Racha' },
  { value: 'premium', label: 'Meses Premium' },
  { value: 'tags', label: 'Emociones' }
];

export const scheduledNotificationTypeOptions = [
  { value: 'MEMBERSHIP', label: 'Membresia' },
  { value: 'LASTLOGIN', label: 'Dias despues de la ultima vez que ingresó' },
  { value: 'COMPLETEREGISTER', label: 'Completó el registro en la App' },
  { value: 'STARTROAD', label: 'inició un camino' },
  { value: 'FINISHEDROAD', label: 'Finalizó un camino' }
];